module.exports = __webpack_public_path__ + "img/pig.f7c0ac54.jpeg";